import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

/* Icônes maison Spiritu’L — trait 1.5, coins très arrondis */
const HomeIcon = ({ active }) => (
  <svg width="23" height="23" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={active ? 1.8 : 1.5} strokeLinecap="round" strokeLinejoin="round">
    <path d="M4.5 10.5 C4.5 10 4.8 9.5 5.2 9.2 L11 4.6 C11.6 4.1 12.4 4.1 13 4.6 L18.8 9.2 C19.2 9.5 19.5 10 19.5 10.5 V17.5 C19.5 18.6 18.6 19.5 17.5 19.5 H15 C14.7 19.5 14.5 19.3 14.5 19 V15.5 C14.5 14.1 13.4 13 12 13 C10.6 13 9.5 14.1 9.5 15.5 V19 C9.5 19.3 9.3 19.5 9 19.5 H6.5 C5.4 19.5 4.5 18.6 4.5 17.5 Z" />
  </svg>
);

const CalmeIcon = ({ active }) => (
  <svg width="23" height="23" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={active ? 1.8 : 1.5} strokeLinecap="round" strokeLinejoin="round">
    <path d="M4 8.5 C6.5 6.6 9.5 6.6 12 8.5 C14.5 10.4 17.5 10.4 20 8.5" />
    <path d="M4 13 C6.5 11.1 9.5 11.1 12 13 C14.5 14.9 17.5 14.9 20 13" />
    <path d="M4 17.5 C6.5 15.6 9.5 15.6 12 17.5 C14.5 19.4 17.5 19.4 20 17.5" />
  </svg>
);

const ProfilIcon = ({ active }) => (
  <svg width="23" height="23" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={active ? 1.8 : 1.5} strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="8.5" r="3.5" />
    <path d="M5.5 19.5 C6.2 16.4 8.8 14.5 12 14.5 C15.2 14.5 17.8 16.4 18.5 19.5" />
  </svg>
);

const BottomNav = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const isActive = (path) => {
    if (path === '/menu') {
      return location.pathname === '/menu' || 
             location.pathname.startsWith('/meditation') || 
             location.pathname.startsWith('/dhikr') || 
             location.pathname.startsWith('/respiration');
    }
    return location.pathname === path;
  };

  const navItems = [
    { path: '/menu', icon: HomeIcon, label: 'Accueil' },
    { path: '/ambiance', icon: CalmeIcon, label: 'Calme' },
    { path: '/profil', icon: ProfilIcon, label: 'Profil' }
  ];

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50">
      <div className="bg-[#FAF9F6] border-t border-gray-100">
        <div className="max-w-md mx-auto px-8 py-4">
          <div className="flex justify-around items-center">
            {navItems.map(({ path, icon: Icon, label }) => {
              const active = isActive(path);
              return (
                <button
                  key={path}
                  onClick={() => navigate(path)}
                  className="flex flex-col items-center justify-center px-6 py-1 transition-all duration-[180ms]"
                >
                  <span className={`transition-colors duration-[180ms] ${active ? 'text-gray-900' : 'text-gray-400'}`}>
                    <Icon active={active} />
                  </span>
                  <span className={`text-[11px] mt-1.5 tracking-wide transition-colors duration-[180ms] ${
                    active ? 'text-gray-900 font-medium' : 'text-gray-400 font-light'
                  }`}>
                    {label}
                  </span>
                </button>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default BottomNav;
